// src/utils/toast.ts
// Utilitaire toast léger — sans dépendance externe
// API compatible avec react-hot-toast : toast.success(), toast.error(), toast.loading()

const STYLES = {
  base: [
    'position:fixed', 'top:16px', 'right:16px', 'z-index:99999',
    'padding:12px 18px', 'border-radius:10px', 'font-size:14px',
    'font-family:system-ui,sans-serif', 'font-weight:500',
    'box-shadow:0 4px 16px rgba(0,0,0,0.15)',
    'display:flex', 'align-items:center', 'gap:8px',
    'max-width:360px', 'cursor:pointer',
    'transition:opacity 0.3s,transform 0.3s',
    'transform:translateX(0)',
    'opacity:1',
  ].join(';'),
  success: 'background:#ecfdf5;color:#065f46;border:1px solid #a7f3d0',
  error:   'background:#fef2f2;color:#991b1b;border:1px solid #fca5a5',
  loading: 'background:#eff6ff;color:#1e40af;border:1px solid #bfdbfe',
  info:    'background:#f0f9ff;color:#0369a1;border:1px solid #bae6fd',
};

const ICONS = {
  success: '✅',
  error:   '❌',
  loading: '⏳',
  info:    'ℹ️',
};

function show(message: string, type: keyof typeof STYLES & keyof typeof ICONS, duration = 4000): void {
  const el = document.createElement('div');
  el.setAttribute('style', `${STYLES.base};${STYLES[type]}`);
  // Icône : HTML statique (ICONS est une constante interne, pas de données utilisateur).
  // Message : inséré via textContent pour éviter tout XSS réflexif
  // (message vient souvent de error.response.data.message / saisie utilisateur).
  const iconSpan = document.createElement('span');
  iconSpan.innerHTML = ICONS[type];
  const messageSpan = document.createElement('span');
  messageSpan.textContent = message;
  el.appendChild(iconSpan);
  el.appendChild(messageSpan);
  el.onclick = () => dismiss(el);

  // Stack existing toasts downward
  const existing = document.querySelectorAll('[data-toast]');
  const offset = 16 + existing.length * 60;
  el.style.top = `${offset}px`;
  el.setAttribute('data-toast', 'true');

  document.body.appendChild(el);

  if (duration > 0) {
    setTimeout(() => dismiss(el), duration);
  }
}

function dismiss(el: HTMLElement): void {
  el.style.opacity = '0';
  el.style.transform = 'translateX(100%)';
  setTimeout(() => {
    if (el.parentNode) el.parentNode.removeChild(el);
  }, 300);
}

const toast = {
  success: (message: string, opts?: { duration?: number }) =>
    show(message, 'success', opts?.duration ?? 4000),

  error: (message: string, opts?: { duration?: number }) =>
    show(message, 'error', opts?.duration ?? 4000),

  loading: (message: string) =>
    show(message, 'loading', 0),

  info: (message: string, opts?: { duration?: number }) =>
    show(message, 'info', opts?.duration ?? 4000),
};

export default toast;
